export const HOME = {
  emergentLink: "emergent-link",
};

export const LANDING = {
  hero: "hero-section",
  echoGrid: "echo-grid",
  darkAgitation: "dark-agitation",
  featureCard: "feature-card",
  bioSection: "bio-section",
  trustBox: "trust-box",
  legalFooter: "legal-footer",

  ctaHero: "cta-hero",
  ctaSolution: "cta-solution",
  ctaBio: "cta-bio",
  ctaFinal: "cta-final",

  leadDialog: "lead-dialog",
  leadForm: "lead-form",
  leadName: "lead-name-input",
  leadEmail: "lead-email-input",
  leadPhone: "lead-phone-input",
  leadMessage: "lead-message-input",
  leadSubmit: "lead-submit-btn",
  leadSuccess: "lead-success",
  leadError: "lead-error",
};
